// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2bFJK","modalFooterButton":"ModalNotes_modalFooterButton__1u7t_"};